'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactMediaPlayer = require('react-media-player');

var _CustomPlayPause = require('components/AudioPlayer/CustomPlayPause');

var _CustomPlayPause2 = _interopRequireDefault(_CustomPlayPause);

var _CustomSeekBar = require('components/AudioPlayer/CustomSeekBar');

var _CustomSeekBar2 = _interopRequireDefault(_CustomSeekBar);

var _videoPlayer = require('./videoPlayer.css');

var _videoPlayer2 = _interopRequireDefault(_videoPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoPlayer = function (_Component) {
  _inherits(VideoPlayer, _Component);

  function VideoPlayer() {
    _classCallCheck(this, VideoPlayer);

    var _this = _possibleConstructorReturn(this, (VideoPlayer.__proto__ || Object.getPrototypeOf(VideoPlayer)).call(this));

    _this.state = {
      isPlaying: false
    };
    return _this;
  }

  _createClass(VideoPlayer, [{
    key: 'onPlay',
    value: function onPlay() {
      this.setState({
        isPlaying: true
      });
    }
  }, {
    key: 'onPause',
    value: function onPause() {
      this.setState({
        isPlaying: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          video = _props.video,
          poster = _props.poster;
      var CurrentTime = _reactMediaPlayer.controls.CurrentTime,
          Duration = _reactMediaPlayer.controls.Duration;

      var isPlaying = this.state.isPlaying;
      var bigPlayClass = isPlaying ? _videoPlayer2.default.bigPlayHidden : _videoPlayer2.default.bigPlay;

      return _react2.default.createElement(
        _reactMediaPlayer.Media,
        null,
        _react2.default.createElement(
          'div',
          { className: _videoPlayer2.default.player },
          _react2.default.createElement(_CustomPlayPause2.default, { className: bigPlayClass }),
          _react2.default.createElement(_reactMediaPlayer.Player, {
            src: video,
            poster: poster,
            onPlay: this.onPlay.bind(this),
            onPause: this.onPause.bind(this)
          }),
          _react2.default.createElement(
            'div',
            { className: _videoPlayer2.default.controls },
            _react2.default.createElement(
              'div',
              { className: _videoPlayer2.default.infoHolder },
              _react2.default.createElement(_CustomPlayPause2.default, { className: _videoPlayer2.default.play }),
              _react2.default.createElement(
                'div',
                { className: _videoPlayer2.default.barHolder },
                _react2.default.createElement(CurrentTime, { className: _videoPlayer2.default.currentTime }),
                _react2.default.createElement(Duration, { className: _videoPlayer2.default.duration }),
                _react2.default.createElement(_CustomSeekBar2.default, { className: _videoPlayer2.default.bar })
              )
            )
          )
        )
      );
    }
  }]);

  return VideoPlayer;
}(_react.Component);

VideoPlayer.propTypes = {
  video: _react.PropTypes.string.isRequired,
  poster: _react.PropTypes.string.isRequired
};

exports.default = VideoPlayer;


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoPlayer/VideoPlayer.js
// module id = 340
// module chunks = 1